import { Dialog, DialogBody, DialogTitle, EditProps } from '@/components/base/dialog'
import { Form as EditForm } from './edit_form'
import { EditVenueContactQuery } from './__generated__/edit_query'
import { Query } from './edit_query'
import { useQuery } from '@apollo/client'
import { Inline as Loading } from '@/components/loading'

interface Props extends EditProps {
  venueId: string
}

export const EditDialog = ({ venueId, id, open, setOpen }: Props) => {
  const { data, loading } = useQuery<EditVenueContactQuery>(Query, { variables: { venueId, venueContactId: id } })

  return (
    <>
      <Dialog open={open} size="3xl" onClose={setOpen}>
        <DialogTitle>
          <div>
            { loading || !data ? <Loading /> : data.venues.nodes[0].venueContacts.nodes[0].name }
          </div>
        </DialogTitle>
        <DialogBody>
          <EditForm id={id} venueId={venueId} onSuccess={() => setOpen(false)} />
        </DialogBody>
      </Dialog>
    </>
  )
}
